import React from "react"
import { Link } from "gatsby"
import logo from "../../images/concord.png"

import "./footer.sass"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const COMMUNITIES = "https://www.concordpacific.com/communities/"
const CORPORATE = "https://www.concordpacific.com"
const TERMS = "https://www.concordpacific.com/terms-of-use/"
const PRIVACY = "https://www.concordpacific.com/privacy-policy/"
const FACEBOOK = "https://www.facebook.com/ConcordPacificDevInc/"
const INS = "https://www.instagram.com/concordpacific/"
const YOUTUBE = "https://www.youtube.com/user/ConcordPacificDevInc"

const Footer = () => (
  <footer>
    <div className="footer-container">
      <div className="concord-logo">
        <img src={logo} alt="Concord Logo" />
      </div>
      <div className="footer-links">
        <div className="footer-nav">
          <ul>
            <li>
              <Link to="/">home</Link>
            </li>
            <li>
              <Link to="/blog/">news</Link>
            </li>
            <li>
              <a href={COMMUNITIES} target="_blank" rel="noopener noreferrer">
                communities
              </a>
            </li>
            <li>
              <a href={CORPORATE} target="_blank" rel="noopener noreferrer">
                concord pacific
              </a>
            </li>
            <li>
              <Link to="/gallery/">gallery</Link>
            </li>
            <li>
              <Link to="/Contact/">contact</Link>
            </li>
          </ul>
        </div>
        <div className="social-links">
          <a href={FACEBOOK} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={["fab", "facebook-square"]} />
          </a>
          <a href={INS} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={["fab", "instagram"]} />
          </a>
          <a href={YOUTUBE} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={["fab", "youtube"]} />
          </a>
          <a
            href="http://www.weibo.com/u/3053263165?refer_flag=1005055013_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={["fab", "weibo"]} />
          </a>
        </div>
      </div>
    </div>
    <div className="policy-container">
      <div className="external-links">
        <span className="copy">
          &copy;
          {new Date().getFullYear()} concord pacific development
        </span>
        <a
          href={TERMS}
          target="_blank"
          rel="noopener noreferrer"
          className="policy"
        >
          Disclaimer
        </a>
        <a
          href={PRIVACY}
          target="_blank"
          rel="noopener noreferrer"
          className="policy"
        >
          Privacy policy
        </a>
      </div>
      <p className="copywrite">
        <span className="author">
          website created by &nbsp;
          <a href="https://hadokenlab.com">hadoken</a>
        </span>
      </p>
    </div>
  </footer>
)

export default Footer
